import { Typography } from '@altibox/design-system-component-lib';
import { css, styled } from 'styled-components';

import { CustomerDebtAlert } from 'app/components/customer-debt-alert';
import { NavigationButton } from 'app/components/navigation-button';
import { breakpointTablet } from 'app/style/breakpoints';
import { colorSecondary200 } from 'app/style/colors';
import { spacing1, spacing2, spacing3, spacing4, spacing5, spacing6, spacing8 } from 'app/style/spacing';
import { HomeGatewayUpgradeAlert } from 'app/components/home-gateway-upgrade-alert';

const baseAlertStyles = css`
    margin-top: ${spacing1};

    @media (min-width: ${breakpointTablet}) {
        margin-top: ${spacing2};
    }
`;

export const StyledContainer = styled.div`
    margin-bottom: ${spacing8};
`;

export const StyledTitle = styled(Typography)`
    margin: ${spacing4} 0 ${spacing3};

    @media (min-width: ${breakpointTablet}) {
        margin: ${spacing6} 0 ${spacing5};
    }
`;

export const StyledContentContainer = styled.div`
    margin: ${spacing5} 0;
    padding-bottom: ${spacing5};
    border-bottom: 1px solid ${colorSecondary200};
`;

export const StyledDescription = styled(Typography)`
    margin-bottom: ${spacing2};
`;

export const StyledMonthlyPrice = styled(Typography)`
    font-weight: bold;
    margin-bottom: ${spacing1};
    display: block;
`;

export const StyledNavigationButton = styled(NavigationButton)`
    margin: ${spacing3} 0;
`;

export const StyledNote = styled(Typography)`
    font-style: italic;
    margin-bottom: ${spacing1};

    @media (min-width: ${breakpointTablet}) {
        margin-bottom: ${spacing2};
    }
`;

export const StyledCustomerDebtAlert = styled(CustomerDebtAlert)`
    ${baseAlertStyles}
`;

export const StyledTotalPrice = styled.div`
    display: flex;
    flex-wrap: wrap;
    max-width: 228px;
    justify-content: space-between;
    margin-bottom: ${spacing1};

    @media (min-width: ${breakpointTablet}) {
        max-width: 252px;
    }
`;

export const StyledPriceTitle = styled(Typography)`
    margin-right: ${spacing1};
`;

export const StyledHomeGatewayUpgradeAlert = styled(HomeGatewayUpgradeAlert)`
    ${baseAlertStyles}
`;
